/**这里下面的测试组件-项目中可删除 */
import storeTest from '../views/test/ms-storeTest.vue'
// import axiosTest from '../views/ms-axiosTest.vue'

let testRoutes = [{
        path: '/storeTest',
        name: 'storeTest',
        component: storeTest
    },
    {
        path: '/axiosTest',
        name: 'axiosTest',
        component: () =>
            import ('../views/test/ms-axiosTest.vue'),
        meta: { title: 'axios测试' }

    },
    {
        path: '/routerTest*',
        /** 
         *  通配符
         *  会匹配以 `/routerTest` 开头的任意路径
         *  path: '*'  匹配所有路径
         *  当使用一个通配符时，$route.params 内会自动添加一个名为 pathMatch 参数。它包含了 URL 通过通配符被匹配的部分
         */
        name: 'routerTest',
        component: resolve =>
            require(['../views/test/ms-routerTest.vue'], resolve)
    }

];

export default testRoutes;


// WEBPACK FOOTER //
// ./src/router/testRouter.js